/* eslint-disable @typescript-eslint/no-unused-vars */
import { TThunkAction } from '../../types/redux';
import { ENewReviewModalStep } from '../../types/newReview';
import { setNewReviewFormStep } from './stepActionsTypes';

export function stepBackActions(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const state = getState();
    const { newReview } = state;
    const {
      meta: { step },
    } = newReview;

    if (step === ENewReviewModalStep.Review) {
      dispatch(setNewReviewFormStep(ENewReviewModalStep.Rating));
    }
  };
}
